import { checkoutEnvironments } from '../../constants';
import { TLoadComgateCheckoutConfig } from '../../types';
import { baseConfigValidator } from '../baseConfigValidator';

/**
 * Check the Comgate Checkout load configuration
 * @param config
 */
export function loadConfigValidator(config: TLoadComgateCheckoutConfig): string | true {
    const validResponse = baseConfigValidator(config);

    if (validResponse !== true) {
        return validResponse;
    }

    if ('environment' in config && (!config.environment || !checkoutEnvironments.includes(config.environment))) {
        return `Config: Invalid environment value '${config.environment}'. Allowed values: ${checkoutEnvironments.join(', ')}.`;
    }

    const isAsyncDefined = 'async' in config;
    const isDeferDefined = 'defer' in config;

    // Check if config.async is a boolean
    if (isAsyncDefined && typeof config.async! !== 'boolean') {
        return 'Config: Invalid async value. Boolean expected.';
    }

    // Check if config.defer is a boolean
    if (isDeferDefined && typeof config.defer! !== 'boolean') {
        return 'Config: Invalid defer value. Boolean expected.';
    }

    // Check if both async and defer are set to true
    if (config.async && config.defer) {
        return 'Config: Only one of async or defer may be set to true.';
    }

    return true;
}
